import React, { Component, Fragment } from 'react';

import { ButtonIcon } from 'components/button';
import { Modal } from 'components/modal';
import { Tabs } from 'components/tabs';
import { I18n, translate } from 'components/translate';
import { BroadcastService } from 'modules/broadcastManager';
import {
  BroadcastDetailUsers,
  BroadcastDetailFilters,
  BroadcastDetailMessage
} from 'modules/broadcastManager/broadcastDetail';
import { UiService } from 'modules/ui';
import PropTypes from 'prop-types';

import './BroadcastDetail.scss';

@translate()
export default class BroadcastDetail extends Component {
  static propTypes = {
    t: PropTypes.func,
    broadcast: PropTypes.object,
    onClose: PropTypes.func
  };

  state = {
    currentTab: 0
  };

  fetchUsers = async (searchText, page) => {
    const { messageId } = this.props.broadcast;
    const response = await BroadcastService.getBroadcastUsers(
      messageId,
      searchText,
      page
    );

    return response;
  };

  onTabChange = (index) => {
    this.setState({ currentTab: index }, () => {
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      UiService.smoothScroll('body', 500);
    });
  };

  get tabs() {
    const { t } = this.props;

    return [
      { name: t('general.message') },
      { name: t('general.users') },
      { name: t('general.filters') }
    ];
  }

  render() {
    const { onClose, broadcast } = this.props;

    return (
      <Modal
        clickOutsideShouldNotClose
        className="broadcast__modal__content"
        onClose={onClose}
      >
        <Modal.Header>
          {(context) => (
            <Fragment>
              <ButtonIcon
                className="close"
                transparent
                type="secondary"
                icon="close"
                onClick={context.actions.closeModal}
              />
              <h2 className="modal_title">
                <I18n label="broadcast.modal.release" />
                {broadcast.title}
              </h2>
            </Fragment>
          )}
        </Modal.Header>
        <Modal.Body>
          <Tabs
            tabs={this.tabs}
            actived={this.state.currentTab}
            onTabChange={this.onTabChange}
          >
            <BroadcastDetailMessage message={broadcast.message} />
            <BroadcastDetailUsers
              fetchUsers={this.fetchUsers}
              descriptionLabel="check_the_users_who_received_the_broadcast"
            />
            <BroadcastDetailFilters messageId={broadcast.messageId} />
          </Tabs>
        </Modal.Body>
      </Modal>
    );
  }
}
